export const DPickerTimes = wcardinal.ui.DPickerTimes;